import color from "../../../theme/color";

/**
 * [background (light), text, ghost]
 */
export const tagColor = {
  primary: [color.primary9, color.primary3, color.primary4],
  /**
   * secondary- light 없음
   */
  secondary: [color.secondary9, color.secondary1, color.secondary3],
  red: [color.red6, color.red3, color.red4],
  orange: [color.orange6, color.orange1, color.orange4],
  yellow: [color.yellow6, color.yellow1, color.yellow4],
  green: [color.green6, color.green1, color.green4],
  mint: [color.mint6, color.mint2, color.mint4],
  blue: [color.blue6, color.blue2, color.blue4],
  pink: [color.pink6, color.pink3, color.pink4],
  teal: [color.teal6, color.teal1, color.blue3],
  /**
   * black 을 gray로 사용 중
   * theme gray는 disabled 로
   */
  black: [color.gray8, color.gray3, color.gray7],
  gray: [color.gray8, color.gray5, color.gray7],
};

export type TagColors = keyof typeof tagColor;

/**
 * 태크 라벨 사이즈
 * [fontSize, lineHeight, padding] figma padding에서 1px 씩 뺌
 */
export const tagSize = {
  small: ["13px", "18px", "0px 7px"],
  medium: ["13px", "18px", "2px 9px"],
  large: ["15px", "20px", "5px 11px"],
};

export type TagSizes = keyof typeof tagSize;
